import pb from '../lib/pocketbase';

export async function getActivos(page, perPage) {
  return await pb.collection('activo').getList(page, perPage, {
    sort: '-created',
    expand: 'tipo',
    $autoCancel: false
  });
}

export async function createActivo(activo) {
  return await pb.collection('activo').create(activo);
}

export async function updateActivo(id, activo) {
  return await pb.collection('activo').update(id, activo);
}

export async function deleteActivo(id) {
  return await pb.collection('activo').delete(id);
}

export async function getActivoAtributos(activoId) {
  try {
    const response = await pb.collection('atributo_activo').getList(1, 50, {
      filter: `activo="${activoId}"`,
      expand: 'atributo',
      $autoCancel: false
    });
    
    return response.items.map(item => ({
      id: item.id,
      atributo: item.expand?.atributo || item.atributo,
      valor: item.valor
    }));
  } catch (error) {
    console.error('Error fetching activo atributos:', error);
    return [];
  }
}
